module.exports = __webpack_public_path__ + "assets/img/7_1551_big.14d78300.jpg";